<template>
  <div class="logo" @click="goPage('Home')">
    <el-image :src="logoSrc" fit="cover"></el-image>
  </div>
</template>

<script>
import logoSrc from '@/assets/img/ieShop_logo_white.png'

export default {
  data() {
    return {
      logoSrc
    }
  },
  methods: {
    goPage(name) {
      this.$router.push({
        name
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .logo {
    background-color: #96BF47;
    height: 49px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    &.collapse {
      justify-content: initial;
      .el-image {
        width: 87px;
        margin-left: 6px;
      }
    }
    .el-image {
      width: 108px;
      flex-shrink: 0;
    }
  }
</style>
